import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Button, HelpBlock } from "components/bootstrap";
import { Spinner } from "components/common";
import useConfiguredModelProviders from "ai-management/model-providers/hooks/useConfiguredModelProviders";
import useDeleteModelProvider from "ai-management/model-providers/hooks/useDeleteModelProvider";
import DeleteConsequence from "ai-management/model-providers/delete/DeleteConsequence";
import DeleteModelProviderDialog from "ai-management/model-providers/delete/DeleteModelProviderDialog";
const DangerZone = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.lg};
    padding-top: ${theme.spacings.md};
    border-top: 1px solid ${theme.colors.variant.lightest.default};
  `
);
const DangerZoneTitle = styled.h4(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.sm};
    font-size: ${theme.fonts.size.body};
    font-weight: 600;
  `
);
const DeleteModelProviderSection = ({ provider, onDeleted }) => {
  const { t } = useTranslation("enterprise_ai");
  const { data: providers, isLoading } = useConfiguredModelProviders();
  const { deleteProvider, isDeleting } = useDeleteModelProvider();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const onDelete = () => deleteProvider(provider.id).then(onDeleted).catch(() => {
  });
  return /* @__PURE__ */ React.createElement(DangerZone, null, /* @__PURE__ */ React.createElement(DangerZoneTitle, null, t("delete_section.danger_zone")), /* @__PURE__ */ React.createElement(HelpBlock, null, isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(
    DeleteConsequence,
    {
      provider,
      providers,
      fallback: /* @__PURE__ */ React.createElement("p", null, t("delete_section.no_feature_uses"))
    }
  )), /* @__PURE__ */ React.createElement(Button, { type: "button", bsStyle: "danger", disabled: isDeleting, onClick: () => setShowDeleteDialog(true) }, t("delete_section.delete_button")), showDeleteDialog && /* @__PURE__ */ React.createElement(
    DeleteModelProviderDialog,
    {
      provider,
      isDeleting,
      onConfirm: onDelete,
      onCancel: () => setShowDeleteDialog(false)
    }
  ));
};
export default DeleteModelProviderSection;
